import { render, staticRenderFns } from "./MarketsDark.vue?vue&type=template&id=36c29130&scoped=true"
import script from "./MarketsDark.vue?vue&type=script&lang=js"
export * from "./MarketsDark.vue?vue&type=script&lang=js"
import style0 from "./MarketsDark.vue?vue&type=style&index=0&id=36c29130&prod&lang=scss"
import style1 from "./MarketsDark.vue?vue&type=style&index=1&id=36c29130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c29130",
  null
  
)

export default component.exports